/**
 * CopyButton Component
 *
 * A button that copies text to clipboard with visual feedback.
 * Wraps Mantine's CopyButton with themed styling.
 */

import { CopyButton as MantineCopyButton, CopyButtonProps as MantineCopyButtonProps } from '@mantine/core';

export interface ThemedCopyButtonProps extends MantineCopyButtonProps {
  /** Value to copy to clipboard */
  value: string;
  /** Timeout in milliseconds for "copied" state */
  timeout?: number;
  /** Render function that receives copy state and copy function */
  children: (payload: { copied: boolean; copy: () => void }) => React.ReactNode;
}

function CopyButton({ value, timeout = 2000, children, ...rest }: ThemedCopyButtonProps) {
  return (
    <MantineCopyButton value={value} timeout={timeout} {...rest}>
      {children}
    </MantineCopyButton>
  );
}

CopyButton.displayName = 'CopyButton';

export default CopyButton;
